<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="alertModal"
      hide-header
      hide-footer
      centered
      @hidden="close()"
    >
      <div class="text-center p-3">
        <font-awesome-icon icon="check-circle" class="icon-success" />
        <p class="text-text" v-if="$store.state.alert.msg">{{ $store.state.alert.msg }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false
    };
  },
  watch: {
    "$store.state.alert.isShow": function() {
      if (this.$store.state.alert.isShow) this.show();
    }
  },
  methods: {
    show() {
      this.showModal = true;
    },
    close() {
      this.$store.commit("UPDATE_GLOBAL_ALERT", {isShow: false, msg : ''});
      this.showModal = false;
    }
  }
};
</script>

<style scoped>
.modal-header {
  border: 0 !important;
  padding: 0;
}

.text-text {
  color: #242424;
  margin-bottom: 0;
  font-size: 26px;
}

.modal-body {
  margin: auto;
  text-align: center;
}
.icon-success {
  font-size: 130px;
  color: #27BDA7;
  margin-bottom: 15px;
}
@media (max-width: 767.98px) {
  /* .text-text {
    font-size: 15px;
  } */
}
</style>
